import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {LinkSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

const COMPONENT_ID = 'pricingTableColumn'

export const PricingTableColumnSchema = buildEntrySchemaFor(COMPONENT_ID, {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      price: z.number().optional(),
      currency: z.string().optional(),
      ctaPrimary: safeOptional(LinkSchema),
      ctaSecondary: safeOptional(LinkSchema),
    }),
  ),
})

export type PricingTableColumn = z.infer<typeof PricingTableColumnSchema>
